export default __webpack_public_path__ + "static/media/UK of GB and Northern Ireland.5ffcd4b2.svg";